module.exports = new __parcel__URL__("heart.91f6fb22.svg").toString();